// Couleurs Nova — modèle de communication efficace (4 styles).
// Chaque utilisateur a un pourcentage 0-100 par couleur, sans contrainte
// de somme (un résultat de test peut totaliser plus ou moins de 100).

export const NOVA_COLORS = ['red', 'yellow', 'green', 'blue'] as const

export type NovaColor = (typeof NOVA_COLORS)[number]

export const NOVA_LABELS: Record<NovaColor, string> = {
  red: 'Rouge',
  yellow: 'Jaune',
  green: 'Vert',
  blue: 'Bleu',
}

export const NOVA_DESCRIPTIONS: Record<NovaColor, string> = {
  red: 'Action, décision, résultats',
  yellow: 'Relations, enthousiasme, idées',
  green: 'Harmonie, écoute, stabilité',
  blue: 'Analyse, rigueur, précision',
}

// Classes Tailwind pour les barres visuelles. On reste sur la palette
// par défaut pour rester cohérent avec le reste de l'app.
export const NOVA_BAR_CLASSES: Record<NovaColor, string> = {
  red: 'bg-red-500',
  yellow: 'bg-yellow-400',
  green: 'bg-emerald-500',
  blue: 'bg-blue-500',
}

export const NOVA_DB_COLUMNS: Record<NovaColor, `nova_${NovaColor}`> = {
  red: 'nova_red',
  yellow: 'nova_yellow',
  green: 'nova_green',
  blue: 'nova_blue',
}
